module.exports = __webpack_public_path__ + "img/staff-2014-rope.13e7d2a9.jpg";